import { getFromBackend } from "../utils/ServiceUtils";

export const loadAllPromotions = async () => {
  return await getFromBackend(`/promotion/all`);
};

